import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        container: {
            height: '100%',
            position: 'relative',
        },
        tableControlRoot: {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        tableControls: {
            display: 'flex',
            alignItems: 'center',
        },
    }
})

export default useStyles
